import { useState } from 'react';
import { logger } from '@fiverr-private/obs';

export const OPEN_DRAWER_EVENT_NAME = 'openSourcingDrawer';
export const WINDOW_INDICATION = 'isSourcingDrawerLoaded';

export const isSourcingDrawerMounted = () => !!window[WINDOW_INDICATION];

export const setIsSourcingDrawerMounted = (isOpen: boolean) => {
    window[WINDOW_INDICATION] = isOpen;
};

export interface PricingData {
    isPriceUpfrontEnabled: boolean;
    priceUpfrontConfiguration?: unknown;
    priceUpfrontContext?: unknown;
    priceUpfrontBuyableFeePolicy?: unknown;
}

export interface LazyDrawerProps {
    source: string;
    setIsLoading?: (isOpen: boolean) => void;
    autoOpen?: boolean;
    isOpen?: boolean;
    enableGoBack?: boolean;
    onClose?: () => void;
    pricingData?: PricingData;
}

export const openSourcingDrawerInternal = ({
    source,
    setIsLoading,
    enableGoBack,
    onClose,
    pricingData,
}: LazyDrawerProps) => {
    if (!isSourcingDrawerMounted()) {
        logger.error(' sourcing drawer is not mounted');
        return false;
    }

    const event = new CustomEvent<LazyDrawerProps>(OPEN_DRAWER_EVENT_NAME, {
        detail: {
            source,
            isOpen: true,
            setIsLoading,
            enableGoBack,
            onClose,
            pricingData,
        },
    });

    window.dispatchEvent(event);
    return true;
};

export const useOpenSourcingDrawer = () => {
    const [isLoading, setIsLoading] = useState(false);

    const openSourcingDrawer = ({ source, onClose, enableGoBack, pricingData }: LazyDrawerProps) => {
        openSourcingDrawerInternal({ source, setIsLoading, onClose, enableGoBack, pricingData });
    };

    return { openSourcingDrawer, isLoading };
};
